module.exports = __webpack_public_path__ + "images/arms.6ab0f53b.webp";